import { createI18n } from 'vue-i18n';
import { watch } from 'vue';
import moment from 'moment-timezone';
import 'moment/locale/de';

export const defaultLang = 'de';

const i18n = createI18n({
  legacy: true,
  locale: defaultLang,
  fallbackLocale: 'en',
  silentFallbackWarn: true,
  messages: {
    de: {
      roles: {
        BASIC: 'Grundfunktion',
        ENDUSER: 'Endanwender',
        MECHANIC: 'Monteur',
        DISTRIBUTOR: 'Vertrieb Torbauer',
        SUPPORT: 'Support TST / Torbauer',
        DoR_INSTALLER: 'DoR Installateur'

      },
      permissions: {
        View_GateControlName: 'Torsteuerungsbezeichnung anzeigen',
        View_Serialnumber: 'Seriennummer Torsteuerung anzeigen',
        View_SWVersion: 'SW Version Torsteuerung anzeigen',
        View_SWVersionIOProc: 'SW Version IO-Proc anzeigen',
        View_Doorcycles: 'Torzyklenzähler anzeigen',
        View_Componentslist: 'Komponentenliste (Sensoren/Aktoren) anzeigen',
        Exec_FactorySetting: 'Werkseinstellung ausführen',
        Exec_ControllerReset: 'Torsteuerung zurücksetzen',
        View_Customer_Serialnumber: 'Kundenseriennummer anzeigen',
        View_Customer_Doortype: 'Kundentortyp anzeigen',
        View_Customer_YOC: 'Herstellungsjahr anzeigen',
        View_Customer_Doorsize: 'Torgröße anzeigen',
        Do_PasswordP999: 'Möglichkeit zur Passworteingabe P.999',
        Read_Parameters: 'Parameter lesen',
        Edit_Parameters: 'Parameter editieren',
        Write_Parameters: 'Parameter schreiben',
        Export_Parameters: 'Parameter exportieren',
        Import_Parameters: 'Parameter importieren',
        Switch_Display: 'Umschaltung 7-Segment LCD',
        Use_Keypad: 'Bedienung der Folientasten',
        View_Inputs: 'Anzeige der Eingangsstatus',
        Edit_Inputs: 'Bedienung der Eingangsstatus',
        View_Outputs: 'Anzeige der Ausgangsstatus',
        View_Faults: 'Anzeige des Fehlerspeichers',
        Export_Faults: 'Fehlerspeicher exportieren',
        Read_Timeswitch: 'Schaltprogramme lesen',
        Edit_Timeswitch: 'Schaltprogramme editieren',
        Write_Timeswitch: 'Schaltprogramme schreiben',
        Import_Timeswitch: 'Schaltprogramme importieren',
        Export_Timeswitch: 'Schaltprogramme exportieren',
        Write_TimeswitchClock: 'Uhrzeit schreiben',
        Read_Log: 'Logdaten auslesen',
        Convert_Log: 'Logdaten konvertieren',
        Export_Log: 'Logdaten exportieren',
        Use_PasswordCalculator: 'Passwortkalkulator verwenden',
        Use_DoR_Recordguide: "DoR Recordguide benutzen",

      },
      lastDayOfValidity: 'Letzter Gültigkeitstag',
      offlineRevalidTimes: {
        '1d': '1 Tag',
        '7d': '7 Tage',
        '14d': '14 Tage',
        '30d': '30 Tage',
      },
      offlineRevalidTime: 'Offline Nutzungszeit',
      maxValidityPeriodTimes: {
        '1M': '1 Monat',
        '3M': '3 Monate',
        '6M': '6 Monate',
        '12M': '12 Monate',
      },
      maxValidityPeriod: 'Maximaler Gültigkeitszeitraum',
      role: 'Rolle',
      lm_role: 'Lizenzmanager-Rolle',
      keypad: 'Taster',
      roll_depend: 'Rollenabhängig',
      allowed: 'Berechtigt',
      denied: 'Nicht berechtigt',
      save: 'Speichern',
      discard: 'Verwerfen',
      cancel: 'Abbrechen',
      edit: 'Bearbeiten',
      reset: 'Zurücksetzen',
      delete: 'Löschen',
      licenseManager: 'Door Assistant Lizenzverwaltung',
      tstToolbox: 'Door Assistant',
      usermanagement: 'Benutzerverwaltung',
      customermanagement: 'Kundenverwaltung',
      registertan: 'Registrierungs TANs',
      permissionmanagement: 'Zugriffsberechtigungen',
      search: 'Suchen',
      legalTexts: 'Rechtstexte',
      licensemanagement: 'Lizenzverwaltung',
      usermanagementRoles: {
        CUSTOMER_USER: 'LM-Benutzer',
        CUSTOMER_ADMIN: 'LM-Admin',
        FEIG_ADMIN: 'LM-Superadmin',
      },
      add_new_user: 'Benutzer hinzufügen',
      add_new_customer: 'Kunde hinzufügen',
      email: 'E-Mail',
      firstname: 'Vorname',
      lastname: 'Nachname',
      password: 'Passwort',
      customer: 'Kunde',
      lastLogin: 'Letzer Login',
      createdAt: 'Erstellt',
      updatedAt: 'Aktualisiert',
      notFound: 'Nichts gefunden.',
      all: 'Alle',
    },
    en: {
      roles: {
        BASIC: 'Basic',
        ENDUSER: 'Enduser',
        MECHANIC: 'Mechanic',
        DISTRIBUTOR: 'Distributor',
        SUPPORT: 'Support',
        DoR_Recordguide: 'DoR Installer'
      },
      permissions: {
        View_GateControlName: 'Show gate control name',
        View_Serialnumber: 'Show gate control serial number',
        View_SWVersion: 'Show SW version gate control',
        View_SWVersionIOProc: 'Show SW version IO-Proc',
        View_Doorcycles: 'Show door cycle counter',
        View_Componentslist: 'Show component list (sensors/actuators)',
        Exec_FactorySetting: 'Execute factory setting',
        Exec_ControllerReset: 'Reset gate controller',
        View_Customer_Serialnumber: 'Display customer serial number',
        View_Customer_Doortype: 'Display customer door type',
        View_Customer_YOC: 'Show year of manufacture',
        View_Customer_Doorsize: 'Show door size',
        Do_PasswordP999: 'Ability to enter password P.999',
        Read_Parameters: 'Read parameters',
        Edit_Parameters: 'Edit parameters',
        Write_Parameters: 'Write parameters',
        Export_Parameters: 'Export parameters',
        Import_Parameters: 'Import parameters',
        Switch_Display: 'Switch 7-segment LCD',
        Use_Keypad: 'Use keypad',
        View_Inputs: 'Display of input status',
        Edit_Inputs: 'Operation of the input status',
        View_Outputs: 'Display of output statuses',
        View_Faults: 'Display of fault memory',
        Export_Faults: 'Export fault memory',
        Read_Timeswitch: 'Read timeswitch programs',
        Edit_Timeswitch: 'Edit timeswitch programs',
        Write_Timeswitch: 'Write timeswitch programs',
        Import_Timeswitch: 'Import timeswitch programs',
        Export_Timeswitch: 'Export timeswitch programs',
        Write_TimeswitchClock: 'Write time',
        Read_Log: 'Read log data',
        Convert_Log: 'Convert log data',
        Export_Log: 'Export log data',
        Use_PasswordCalculator: 'Use password calculator',
        Use_DoR_Recordguide: "Use DoR Recordguide",
      },
      lastDayOfValidity: 'Last day of validity',
      offlineRevalidTimes: {
        '1d': '1 Day',
        '7d': '7 Days',
        '14d': '14 Days',
        '30d': '30 Days',
      },
      offlineRevalidTime: 'Offline revalidation time',

      maxValidityPeriodTimes: {
        '1M': '1 Month',
        '3M': '3 Months',
        '6M': '6 Months',
        '12M': '12 Months',
      },
      maxValidityPeriod: 'Maximum validity period',
      lm_role: 'Licence Manager Role',
      role: 'Role',
      keypad: 'Keypad',
      roll_depend: 'Role-dependent',
      allowed: 'Allowed',
      denied: 'Denied',
      save: 'Save',
      discard: 'Discard',
      cancel: 'Cancel',
      edit: 'Edit',
      reset: 'Reset',
      delete: 'Delete',
      licenseManager: 'Door Assistant License Manager',
      tstToolbox: 'Door Assistant',
      usermanagement: 'User management',
      customermanagement: 'Customer management',
      registertan: 'Register TANs',
      permissionmanagement: 'Access permissions',
      search: 'Search',
      legalTexts: 'Legal texts',
      licensemanagement: 'License management',
      usermanagementRoles: {
        CUSTOMER_USER: 'LM-User',
        CUSTOMER_ADMIN: 'LM-Admin',
        FEIG_ADMIN: 'LM-Superadmin',
      },
      add_new_user: 'Add user',
      add_new_customer: 'Add customer',
      email: 'E-Mail',
      firstname: 'Firstname',
      lastname: 'Lastname',
      password: 'Password',
      customer: 'Customer',
      lastLogin: 'Last login',
      createdAt: 'Created',
      updatedAt: 'Updated',
      notFound: 'Nothing found.',
      all: 'All',
    },
  },
});

watch(
  () => i18n.global.locale,
  (locale) => moment.locale(locale),
  { immediate: true, flush: 'sync' }
);

export default i18n;
